import SEO from "@/components/feature/SEO";
import AdminLayout from "@/components/feature/AdminLayout";
import { Shield, Bell, Lock, UserCircle } from "lucide-react";

export default function AdminSettingsPage() {
  return (
    <AdminLayout>
      <SEO title="Admin Settings | ExpertAdvise.in" noindex />
      <div className="p-4 md:p-8 max-w-3xl mx-auto">
        <div className="mb-6 md:mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-slate-900">Settings</h1>
          <p className="text-sm text-slate-500 mt-1">Manage your admin account and notification preferences.</p>
        </div>

        <div className="space-y-4">
          <div className="bg-white rounded-xl border border-slate-200 p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                <UserCircle className="w-5 h-5 text-primary-600" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Profile</h3>
                <p className="text-xs text-slate-500">Update your name, email, and password.</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-slate-700 mb-1.5">Full Name</label>
                <input type="text" defaultValue="Admin User" className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-700 mb-1.5">Email</label>
                <input type="email" defaultValue="admin@expertadvise.in" className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-primary-400" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-amber-50 flex items-center justify-center">
                <Bell className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Notifications</h3>
                <p className="text-xs text-slate-500">Configure email and WhatsApp alerts.</p>
              </div>
            </div>
            <div className="space-y-3">
              {[
                "New lead notification",
                "Appointment booked",
                "Claim status update",
                "Weekly summary report",
              ].map((label) => (
                <label key={label} className="flex items-center gap-3 cursor-pointer">
                  <input type="checkbox" defaultChecked className="rounded border-slate-300 text-primary-600 focus:ring-primary-500 w-4 h-4" />
                  <span className="text-sm text-slate-700">{label}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center">
                <Lock className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Security</h3>
                <p className="text-xs text-slate-500">Change password and enable 2FA.</p>
              </div>
            </div>
            <button className="bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
              Change Password
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}